import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'
import Button from '../../components/Button'


const ConfirmDeleteModal = ({ open, title, content, onConfirm, onCancel }) => {
	const [busy, setBusy] = useState(false)

	useEffect(() => {
		if (open) setBusy(false)
	}, [open])

	const confirm = async () => {
		if (busy) return
		setBusy(true)
		try {
			const ok = await onConfirm()
			if (!ok) setBusy(false)
		} catch (e) {
			setBusy(false)
		}
	}

	return (
		<Modal
			open={open}
			title={title}
			onCancel={busy ? undefined : onCancel}
			footer={null}
			destroyOnClose
			maskClosable={!busy}
		>
			<div className="mt-4 text-base">{content}</div>
			<div className="flex justify-end gap-2 mt-6">
				<Button
					className="!h-10 !bg-gray-400"
					onClick={onCancel}
					disabled={busy}
				>
					Bekor qilish
				</Button>
				<Button
					className="!h-10 !bg-red-600"
					onClick={confirm}
					isLoading={busy}
				>
					O‘chirish
				</Button>
			</div>
		</Modal>
	)
}

export default ConfirmDeleteModal
